import type CreativeSDK from '@cesdk/cesdk-js';
import { GQLProductFragment, GQLProductSideSideType } from '@theprintbar/graphql';
import { isNeckLabelBlock } from '@theprintbar/shared';
import { getPage } from './block';
import { addGraphic } from './graphic';
import { getPageScaleFactor } from './page';
import { addText } from './text';

const sizePlaceholderId = 'labelSize';

export { isNeckLabelBlock };

export function updateNeckLabelSize(editor: CreativeSDK, size: string) {
	editor.engine.variable.setString(sizePlaceholderId, size);
	console.log('updating size');
}

export async function addNeckLabelBlocks(editor: CreativeSDK, product: GQLProductFragment) {
	const { block } = editor.engine;
	const page = getPage(editor, GQLProductSideSideType.Label);
	if (!page || !product.sides.find(s => s.side === GQLProductSideSideType.Label)) return;

	//Remove any old neck label blocks
	const existing = block.findAll().filter(b => isNeckLabelBlock(b, editor));
	existing.forEach(e => block.destroy(e));

	const scale = getPageScaleFactor(editor.engine, page);

	const basicProps = {
		editor,
		page,
		meta: {
			neckLabel: 'true',
		},
	};
	//Add the label size, instructions and icons
	const sizeBlock = addText({
		...basicProps,
		text: 'L',
		top: 36,
		height: 10,
		placeholderId: sizePlaceholderId,
	});
	// const locationBlock = addText({
	// 	...basicProps,
	// 	text: 'MADE IN BANGLADESH',
	// 	height: 4,
	// 	top: 40,
	// });
	const materialBlock = addText({
		...basicProps,
		text: product.labelMaterial || '',
		height: 4,
		top: 46,
	});
	const icons: number[] = [];

	const isEven = (product.labelIcons || []).length % 2 === 0;
	const centerShift = isEven ? 3 * scale : 0;
	const stride = 8 * scale;
	product.labelIcons?.forEach((icon, index) => {
		if (!icon.image?.url) return;
		const iconBlock = addGraphic({
			...basicProps,
			url: icon.image?.url,
			width: 6,
			height: 6,
			top: 52,
		});

		const offset = Math.floor((index + 1) / 2) * (index % 2 === 0 ? -1 : 1);
		const startingX = block.getPositionX(iconBlock);
		block.setPositionX(iconBlock, startingX + offset * stride - centerShift);
		icons.push(iconBlock);
	});
	//Full lock — Adopters shouldn't be able to select, move, edit text, or delete these.
	//`editor/select` alone is insufficient in v1.77; the text/edit + layer/move + destroy
	//scopes leak through unless individually disabled.
	[sizeBlock, materialBlock, ...icons].forEach(blockId => {
		block.setScopeEnabled(blockId, 'editor/select', false);
		block.setScopeEnabled(blockId, 'layer/move', false);
		block.setScopeEnabled(blockId, 'text/edit', false);
		block.setScopeEnabled(blockId, 'lifecycle/destroy', false);
	});
}
